import "./style.css";
import Orchestrator from "./ThreeJS/Orchestrator.js";
import gsap from "gsap";

const orchestrator = new Orchestrator(document.querySelector("canvas.webgl"));

import FooterSpheres from "./ThreeJS/FooterSpheres.js";

const footerCanvas = document.getElementById('footer-spheres-canvas');
if (footerCanvas) {
    let footerInstance = null;
    const footerObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Destroy previous instance and restart fresh every time
                if (footerInstance) footerInstance.destroy();
                footerInstance = FooterSpheres(footerCanvas, { gravity: 0 });
                setTimeout(() => {
                    if (footerInstance) footerInstance.spheres.setGravity(0.5);
                }, 300);
            } else {
                if (footerInstance) {
                    footerInstance.destroy();
                    footerInstance = null;
                }
            }
        });
    }, { threshold: 0.1 });
    footerObserver.observe(footerCanvas);
}

function updateTime() {
    const timeElement = document.getElementById("local-time");
    if (timeElement) {
        const now = new Date();
        const options = {
            timeZone: "Asia/Kolkata",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        };
        timeElement.textContent = now.toLocaleTimeString("en-US", options) + " IST";
    }
}

updateTime();
setInterval(updateTime, 60000);

// Staggered fade-in animation for text elements
const animatedElements = [
    ".nav-logo a",
    ".nav-links a",
    ".nav-socials a",
    ".nav-time p",
    ".hero-section h1",
    ".network-graphic",
    ".bar-location p",
    ".bar-projects a",
    ".bar-availability a",
];

gsap.fromTo(
    animatedElements,
    {
        opacity: 0,
        y: 20,
    },
    {
        duration: 1,
        opacity: 1,
        y: 0,
        stagger: 0.1,
        ease: "power3.out",
        delay: 0.5,
    },
);

gsap.to(".nav-logo a", {
    duration: 2,
    color: "#1a4d2e",
    delay: 1.5,
    ease: "power2.inOut",
    repeat: -1,
    yoyo: true,
    repeatDelay: 3
});

// Scroll animations for About section
const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
        }
    });
}, { threshold: 0.15 });

document.querySelectorAll('.pop-up-element').forEach(el => observer.observe(el));

// Contact overlay
const contactOverlay = document.getElementById('contact-overlay');
const contactClose = document.getElementById('contact-close');

function openContact() {
    contactOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
}

function closeContact() {
    contactOverlay.classList.remove('open');
    document.body.style.overflow = '';
}

document.getElementById('nav-contact-link')?.addEventListener('click', (e) => { e.preventDefault(); openContact(); });
document.getElementById('bar-contact-link')?.addEventListener('click', (e) => { e.preventDefault(); openContact(); });
document.getElementById('nav-start-btn')?.addEventListener('click', openContact);
contactClose?.addEventListener('click', closeContact);
contactOverlay?.addEventListener('click', (e) => { if (e.target === contactOverlay) closeContact(); });
document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeContact(); });

document.getElementById('contact-form')?.addEventListener('submit', (e) => {
    e.preventDefault();
    const btn = e.target.querySelector('.form-submit');
    btn.textContent = 'Sent!';
    btn.style.background = '#43e97b';
    setTimeout(() => {
        btn.innerHTML = 'Send Message <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';
        btn.style.background = '';
        e.target.reset();
        closeContact();
    }, 1800);
});
